export default (config = {}, selected) => {
    return {
        model: selected,
        readonly: config.readonly,
        trueValue: config.trueValue,
        falseValue: config.falseValue,

        initialize() {
            this.$watch('model', () => {
                if (!this.isTrue() && !this.isFalse()) {
                    this.model = this.falseValue;
                }
            });
        },
        toggleValue() {
            this.isFalse() ?
                this.setTrue() :
                this.setFalse();
        },
        setTrue() {
            if (!this.readonly) {
                this.model = this.trueValue;
            }
        },
        setFalse() {
            if (!this.readonly) {
                this.model = this.falseValue;
            }
        },
        isTrue() {
            return this.model === this.trueValue;
        },
        isFalse() {
            return this.model === this.falseValue;
        }
    };
}